// extracted by mini-css-extract-plugin
export default {"container":"baselayout_container__0Kdki","content":"baselayout_content__YwEmw"};